import { render, staticRenderFns } from "./NewPasswordComponent.vue?vue&type=template&id=9bbbe8ea&scoped=true&"
import script from "./NewPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./NewPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbe8ea",
  null
  
)

export default component.exports